class SmartBullets {

	static _defaults = {
		selectors: {},
		settings: {}
	};

	constructor( SmartBulletsEl, selectors = {}, settings = {} ) {
		this.selectors = Object.assign( {}, SmartBullets._defaults.selectors, selectors );
		this.settings = Object.assign( {}, SmartBullets._defaults.settings, settings );

		this.root = SmartBulletsEl;
		this.items = this.root.querySelectorAll( this.selectors.items );

		var containerObserver = new MutationObserver( ( mutations ) => {
			mutations.forEach( ( mutation ) => {
				if( mutation.type !== 'attributes' && mutation.attributeName !== 'data-index' ) return;

				var index = parseInt( mutation.target.dataset.index );

				if( this.items.length === 0 ) return;

				if( this.items.length > 3 ) {
					this.items.forEach( function( item ) {
						item.classList.remove( 'hidden' );
					} );

					this.items.forEach( ( item, currentIndex ) => {
						if( currentIndex < ( index - 2 ) && index !== ( this.items.length - 1 ) ) item.classList.add( 'hidden' );
						if( currentIndex < ( index - 3 ) && index === ( this.items.length - 1 ) ) item.classList.add( 'hidden' );
						if( currentIndex > ( index + 2 ) && index !== 0 ) item.classList.add( 'hidden' );
						if( currentIndex > ( index + 3 ) && index === 0 ) item.classList.add( 'hidden' );
					} );

					if( index > 1 && index < this.items.length - 2 ) {
						this.items[index - 2].classList.add( 'is-tinified' );
						this.items[index - 1].classList.remove( 'is-tinified' );
						this.items[index + 1].classList.remove( 'is-tinified' );
						this.items[index + 2].classList.add( 'is-tinified' );
					}

					if( index === 0 ) {
						this.items[index + 3].classList.add( 'is-tinified' );
						this.items[index + 2].classList.remove( 'is-tinified' );
						this.items[index + 1].classList.remove( 'is-tinified' );
						this.items[index].classList.remove( 'is-tinified' );
					}

					if( index === 1 ) {
						this.items[index - 1].classList.remove( 'is-tinified' );
						this.items[index + 2].classList.add( 'is-tinified' );
					}

					if( index === this.items.length - 1 ) {
						this.items[index - 2].classList.remove( 'is-tinified' );
						this.items[index - 1].classList.remove( 'is-tinified' );
						this.items[index - 3].classList.add( 'is-tinified' );
					}

					if( index === this.items.length - 2 ) {
						this.items[index + 1].classList.remove( 'is-tinified' );
						this.items[index - 1].classList.remove( 'is-tinified' );
						this.items[index - 2].classList.add( 'is-tinified' );
					}
				}
			} );
		} );

		this.items.forEach( ( item, index ) => {
			item.dataset.paginationIndex = index;

			if( item.classList.contains( this.settings.activeClass ) ) {
				this.root.dataset.index = index;
			}
		} );

		containerObserver.observe( this.root, { attributes: true } );

		//Prevent shifting
		setTimeout( () => {
			this.root.classList.add( 'is-initialized' );
		}, 2 );

		return [
			containerObserver
		];
	}
}

function initSmartBullets( elem, selectors = {}, settings = {}, scopeEl = document ) {
	const smartBulletsEls = scopeEl.querySelectorAll( elem );
	let observers = [];

	if ( smartBulletsEls ) {
		smartBulletsEls.forEach( smartBulletsEl => {
			const newObservers = new SmartBullets( smartBulletsEl, selectors, settings );
			observers.push( newObservers );
		} );
	}

	return observers;
}

const initSliderSmartBullets = function( scopeEl = document, elem = '.mdl_slider__pager' ) {
	initSmartBullets(
		elem,
		{
			items: '.mdl_slider__pager-item'
		},
		{
			activeClass: 'is-active'
		},
		scopeEl
	);
}

const initPhotoswipeSmartBullets = function() {

	return initSmartBullets(
		'.pswp__bullets',
		{
			items: '.pswp__bullet'
		},
		{
			activeClass: 'is-active'
		}
	);
}

export {
	SmartBullets as default,
	initSliderSmartBullets,
	initPhotoswipeSmartBullets
}
